import UI from "@mile-meeting/mile-ui";
import { TitleContainer, Container, TabContainer, TabItem, BtnContainer } from "./index.styles";
import { useState } from "react";
import AllMembers from "./all-members";
import PermissionTableModal from "./permission-guide-modal";
import InviteMember from "./invite-member";
import InviteModal from "./invite-modal";
import { useRecoilValue } from "recoil";
import { member } from "recoil/recoilState";
import { superAdminRoles, UserRole } from "utils/role";
import { useNavigate } from "react-router-dom";

const MemberManage = () => {
  const memberInfo = useRecoilValue(member);
  const hasSuperAdminRoles = superAdminRoles.includes(memberInfo?.role ?? UserRole.Staff);
  const [section, setSection] = useState<"전체 멤버" | "초대 현황">("전체 멤버");
  const [openPermissionModal, setOpenPermissionModal] = useState<boolean>(false);
  const [openInviteModal, setOpenInviteModal] = useState<boolean>(false);
  const [updateInvite, setUpdateInvite] = useState<boolean>(false);
  const navigator = useNavigate();

  //* INFO: 권한 자세히 알아보기 버튼을 클릭했을 때 모달을 띄우는 로직입니다.
  const onHandleOpenPermissionModal = () => {
    setOpenPermissionModal(true);
  };

  return (
    <Container>
      <TitleContainer>
        <UI.Typography type="title03" fontStyle="bold" color="var(--alias-color-label-neutral)">
          멤버 관리
        </UI.Typography>
        {hasSuperAdminRoles && (
          <BtnContainer>
            <UI.Button
              title="멤버 초대하기"
              prefixIcon="addCircle"
              showPrefixIcon
              onClick={() => setOpenInviteModal(true)}
            />
          </BtnContainer>
        )}
      </TitleContainer>
      <TabContainer>
        <TabItem selected={section === "전체 멤버"} onClick={() => setSection("전체 멤버")}>
          <UI.Typography
            type="body01 normal"
            fontStyle="bold"
            color={
              section === "전체 멤버" ? "var(--alias-color-primary-normal" : "var(--alias-color-label-alternative)"
            }
          >
            전체 멤버
          </UI.Typography>
        </TabItem>
        {hasSuperAdminRoles && (
          <TabItem selected={section === "초대 현황"} onClick={() => setSection("초대 현황")}>
            <UI.Typography
              type="body01 normal"
              fontStyle="bold"
              color={
                section === "초대 현황" ? "var(--alias-color-primary-normal" : "var(--alias-color-label-alternative)"
              }
            >
              초대 현황
            </UI.Typography>
          </TabItem>
        )}
        <UI.ButtonGroups.Text
          onClick={onHandleOpenPermissionModal}
          styles={{ container: { marginLeft: "auto" } }}
          title="권한 자세히 알아보기"
          prefixIcon="question"
          showPrefixIcon
          size="small"
          type="secondary"
        />
      </TabContainer>
      <AllMembers open={section === "전체 멤버"} />
      <InviteMember open={section === "초대 현황"} update={updateInvite} setUpdateInvite={setUpdateInvite} />
      <PermissionTableModal modalIsOpen={openPermissionModal} closeModal={() => setOpenPermissionModal(false)} />
      <InviteModal
        modalIsOpen={openInviteModal}
        closeModal={() => setOpenInviteModal(false)}
        onUpdate={() => setUpdateInvite(true)}
      />
    </Container>
  );
};

export default MemberManage;
